<template>
  <b-container>
    <div class="mt-4 d-flex justify-content-between align-items-center">
      <back-arrow :bilan-type="bilanType"
                  :params="{operationId: operationId}"
                  :sub-title-ope="operationName"
                  :title="$t('Facture')"
                  route-back="OperationShow"/>

      <div class="d-flex justify-content-end ml-auto mt-0">
        <b-button class="ml-2 fixed-card-size-button" variant="primary"
                  @click="clickOnCreateBtn()">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.e') }} {{ $t('facture') }}
        </b-button>
      </div>
    </div>
    <div class="row m-0">
      <div class="d-flex justify-content-end ml-auto">
        <b-card :class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`" class="backtotal ml-2 fixed-card-size">
          <div class="">
            {{ $t('facture.devis.signes.ttc') }}
          </div>
          <div class="level-one-title ml-auto text-right">
            {{ totalttcDevis | formatEuro }}
          </div>
        </b-card>

        <b-card :class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`" class="backtotal ml-2 fixed-card-size"
                size="sm">
          <div class="">
            {{ $t('facture.sansdevisttc') }}
          </div>
          <div class="level-one-title ml-auto text-right">
            {{ totalSansDevisTTC | formatEuro }}
          </div>
        </b-card>

        <b-card :class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`" class="backtotal ml-2 fixed-card-size"
                size="sm">
          <div class="">
            {{ $t('facture.totalttc') }}
          </div>
          <div class="level-one-title ml-auto text-right">
            {{ totalttcDevis + totalSansDevisTTC | formatEuro }}
          </div>
        </b-card>

        <b-card :class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`" class="backtotal ml-2 fixed-card-size"
                size="sm">
          <div class="">
            {{ $t('facture.paidttc') }}
          </div>
          <div class="level-one-title ml-auto text-right">
            {{ totalPayeesTTC | formatEuro }}
          </div>
        </b-card>

        <b-card :class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`" class="backtotal ml-2 fixed-card-size"
                size="sm">
          <div class="">
            {{ $t('facture.rapttc') }}
          </div>
          <div class="level-one-title ml-auto text-right">
            {{ rapTTC | formatEuro }}
          </div>
        </b-card>


      </div>
    </div>

    <b-card class="mt-2 mb-4 shadow-sm">
      <b122-table
        ref="B122TableFacture"
        :empty-text="$t('facture.emptyText')"
        :empty-title="$t('facture.emptyTitle')"
        :fields="tableFieldsFacture"
        :get-b122-table-results-url="'/facturePayment/getB122TableResults?restrictbylong-operationId=' + operationId"
        :identifier="'B122TableFacture'"
        :use-filters="true"
        :use-pagination="false"
        init-b122-table-url="/facturePayment/initB122Table"
        @add="clickOnCreateBtn"
        @clickOnDeleteBtn="clickOnDeleteFactureBtn"
        @clickOnEditBtn="clickOnEditFactureBtn"
        @clickOnShowBtn="clickOnShowFactureBtn">


        <template #cell(actions)="row">
          <div class="actions-container text-right">
            <button class="show-action-btn edit mr-1"
                    @click="clickOnEditFactureBtn(row)">
              <pencil-icon size="18"/>
            </button>
            <button class="show-action-btn delete" @click="clickOnDeleteFactureBtn(row)">
              <trash-icon size="18"/>
            </button>
          </div>
        </template>


        <template #cell(facture.devis.numero)="data">
          <template v-if="data.item.facture.devis && data.item.facture.id">
            <span v-if="data.item.facture.devis.numero && data.item.facture.devis.numero.trim()!==''">
              {{ data.item.facture.devis.numero }}
            </span>
            <span v-else>{{ "N/A" }}</span>
          </template>
          <template v-else>{{ "-" }}</template>
        </template>

        <template #cell(facture.prixTTC)="data">
          <template v-if="data.value!==''"> {{ data.value | formatEuro }}</template>
        </template>

        <template #cell(facture.prixTVA)="data">
          <template v-if="data.value!==''"> {{ data.value }}</template>
        </template>


        <template #cell(facture.devis)="data">
          <template v-if="data.item.devis"> {{ data.item.devis.tostring }}</template>
          <template v-else-if="data.item.operationConstruction"> {{ data.item.operationConstruction.name }}</template>
        </template>


        <template #cell(facture.statusObj)="data">
          <span
            :style="{borderColor: data.item.facture.statusObj.mainColor.toString(), backgroundColor: data.item.facture.statusObj.secondaryColor.toString(), color: data.item.facture.statusObj.textColor ? data.item.facture.statusObj.textColor.toString() : '#000'}"
            class="bold-text main-color-text p-2"
            style="display: inline-block; border: 1px solid; border-radius: 4px;">
            {{ $t(data.item.facture.statusObj.text) }}
          </span>
        </template>

        <template #cell(documents)="data">
          <div v-for="document in data.item.documents" class="row">
            <b-link class="light-blue-color underline-text ml-3 mb-1" v-on:click="getDocument(document.fileUrl)">
              {{ truncateText(document.fileName, 45) }}
            </b-link>
          </div>
        </template>
      </b122-table>
    </b-card>
    <Item-delete-modal
      id="factureDeleteModal"
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="factureToDelete"
      controllerName="facturePayment"
      itemSingularName="facture"
      itemSingularNameUpp="Facture"
      @didDeleteItem="didDeleteFacture()">
    </Item-delete-modal>
  </b-container>
</template>

<script>
import api from '../../services/api'
import BackArrow from "../../components/b122/BackArrow.vue";
import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";

export default {
  name: "OperationDevisIndex",

  components: {
    BackArrow,
    B122Table,
    ItemDeleteModal
  },


  data() {
    return {
      operationId: this.$route.params.operationId,
      showConstructionMode: 'budget',
      statusFacture: [],
      nbFactures: "-",
      bilanType: "",
      totalttcDevis: null,
      totalAvecDevisTTC: null,
      totalPayeesTTC: null,
      totalSansDevisTTC: null,
      operationName: "",
      rapTTC: null,
      factureToDelete: {},
      tableFieldsFacture: [
        {
          label: this.$t('See'),
          key: 'show',
          sortable: false,
        },
        {
          label: this.$t('Nom'),
          key: 'facture.nom',
          sortable: true,
        },
        {
          label: this.$t('Devis'),
          key: 'facture.devis.numero',
          sortable: false,
        },
        {
          label: this.$t("facture.PrixTTC"),
          key: 'facture.prixTTC',
          sortable: true,
        },
        {
          label: this.$t("facture.PrixTVA"),
          key: 'facture.prixTVA',
          sortable: true,
        },
        {
          label: this.$t("facture.issued.date"),
          key: 'facture.issuedDate',
          sortable: true,
          formatter: function (value) {
            return value.split('-').reverse().join('/')
          }
        },
        {
          label: this.$t('OperationTask.status'),
          key: 'facture.statusObj',
          sortable: true,
        },
        {
          label: this.$t("facture.paid.date"),
          key: 'facture.paidDate',
          sortable: true,
          formatter: function (value) {
            if (!value) return '-'
            return value.split('-').reverse().join('/')
          }
        },
        {
          label: '',
          key: 'actions',
        }],
    }
  },

  async mounted() {
    await this.fetchData()
    await this.getCardsData()
  },

  methods: {


    async getCardsData() {
      await api
        .get(`/facturePayment/getCardsData/${this.operationId}`)
        .then(response => {
          const {
            nbFacture,
            totalttcDevis,
            totalAvecDevisTTC,
            rapTTC,
            totalPayeesTTC,
            totalSansDevisTTC
          } = response.data;
          this.nbFactures = nbFacture;
          this.totalttcDevis = totalttcDevis;
          this.totalAvecDevisTTC = totalAvecDevisTTC;
          this.rapTTC = rapTTC;
          this.totalPayeesTTC = totalPayeesTTC;
          this.totalSansDevisTTC = totalSansDevisTTC;
        })

    },


    clickOnFactureBtn() {
      this.$router.push({
        name: 'OperationDevisIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.operationName = response.data.name
            this.bilanType = response.data.bilanType
            if (response.data && response.data.bilanType === "AVP") {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 2,
                }
              })
            }
          })
      }
    },

    clickOnBudgetBtn() {
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 2,
        }
      })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationFactureCreate',
        params: {
          operationId: this.operationId,
        }
      })
    },

    async fetchData() {
      await this.getOperation()
      await this.getStatusFacture()
    },

    async getStatusFacture() {
      await api
        .get(`/facturePayment/getStatusFacture`)
        .then(response => {
          this.statusFacture = response.data
        })
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus();
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...';
      }
      return text;
    },

    saveStatusFacture(id, status) {
      let data = new FormData()
      data.append('status', status)
      let url = '/facturePayment/updateStatus/' + id

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(() => {
          this.$refs.B122TableFacture.refreshTable()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationFactureIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    clickOnShowFactureBtn(row) {
      this.$router.push({
        name: 'OperationFactureShow',
        params: {
          factureId: row.item.facture.id,
          operationId: this.operationId
        }
      })
    },


    clickOnEditFactureBtn(row) {
      this.$router.push({
        name: 'OperationFactureEdit',
        params: {
          factureId: row.item.facture.id,
          operationId: this.operationId
        }
      })
    },

    clickOnDeleteFactureBtn(row) {
      this.factureToDelete = row.item.facture
      this.$bvModal.show('factureDeleteModal')
    },

    async didDeleteFacture() {
      if (this.factureToDelete && this.factureToDelete.numero) {
        this.successToast((this.$i18n.t('Facture')) + ' "' + this.factureToDelete.numero + '" ' + this.$i18n.t('deleted'))
      }
      this.$refs.B122TableFacture.refreshTable()
      await this.getCardsData()
      let needPopUpCheckPrice = await this.fetchNeedPopUpCheckPrice()
      if(needPopUpCheckPrice) {
        let message =  this.factureToDelete && this.factureToDelete.operationConstruction && this.factureToDelete.operationConstruction.id ? this.$i18n.t('operationConstruction.empty.facture.update.price') : this.$i18n.t('operationHonoraire.empty.facture.update.price')
        this.$alert(message.toString(),"Attention").then(() => {
        });
      }
      this.factureToDelete = null
    },

    async fetchNeedPopUpCheckPrice() {
      let responseApi = null
      if (this.factureToDelete && this.factureToDelete.id && this.factureToDelete.hasOwnProperty("devis") && !this.factureToDelete.devis && this.factureToDelete.hasOwnProperty("operationConstruction") && this.factureToDelete.operationConstruction && this.factureToDelete.operationConstruction.hasOwnProperty("id") && this.factureToDelete.operationConstruction.id) {
        await api
          .get(`/operationConstruction/needPopUpCheckPrice/${this.factureToDelete.operationConstruction.id}`)
          .then(response => {
            responseApi =  response.data
          })
      } else if (this.factureToDelete && this.factureToDelete.id && this.factureToDelete.hasOwnProperty("devis") && !this.factureToDelete.devis && this.factureToDelete.hasOwnProperty("operationHonoraire") && this.factureToDelete.operationHonoraire && this.factureToDelete.operationHonoraire.hasOwnProperty("id") && this.factureToDelete.operationHonoraire.id) {
        await api
          .get(`/operationHonoraire/needPopUpCheckPrice/${this.factureToDelete.operationHonoraire.id}`)
          .then(response => {
            responseApi =  response.data
          })
      }
      return responseApi ? responseApi == "true" || responseApi == true : false
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },
  }
}
</script>

<style scoped>
.backtotal {
  padding: 0 !important;
  color: var(--main-white);
  border-radius: 0 !important;
}

.backtotal > .card-body {
  padding: 0.25rem !important;
}

.fixed-card-size {
  min-width: 175px;
}

.fixed-card-size-button {
  min-width: 175px;
}


</style>



// WEBPACK FOOTER //
// src/views/OperationFacture/OperationFactureIndex.vue